export const inventoryItemKeys = {
  all: () => ['INTVENTORY_ITEMS'] as const,
  details: (itemId: string) => ['DETAILS', itemId] as const,
};
